import { Pipe, PipeTransform } from '@angular/core';
import { UiFlowchartService } from './ui-flowchart.service'

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {

    constructor(
        private service: UiFlowchartService
    ) { }

    transform(name: any, defaultVal = ''): any {
        const r = this.service.getI18nValue(name);
        return r ? r : defaultVal;
    }
}
